import React, { useState } from "react";
import { calculateFiatTradeFee, calculateTradeFee } from "../helpers";
import { CirlceQuestionmark } from "../../../TradeIcons";
import { t } from "../../../../../utils/i18n";

const TradeInput = ({
  offer,
  hasError,
  validationMessage,
  offerTypeDisplay,
  highlightUSD,
  highlightFIAT,
  cryptoAmount,
  onCryptoChange,
  tradeFee,
  availableBalance,
  fiatAmount,
  onFiatChange,
  sellerRate,
  selectedValue,
  userBankAccounts,
  handleSelectChange,
  submitting,
  onSubmit,
}) => {

  const verb =
    offerTypeDisplay === "buy"
      ? t("p2p.common.verb_buy")
      : offerTypeDisplay === "sell"
      ? t("p2p.common.verb_sell")
      : "";
  const [showBalance, setShowBalance] = useState(true); // state to toggle balance visibility

  const toggleBalanceVisibility = () => {
    setShowBalance(!showBalance); // toggle balance visibility on icon click
  };
  return (
    <div className="offer-numbers">
      <div>
        <div className="create-trade-section">
          <div className="create-trade-card">
            {hasError && (
              <div className="createtrade-error">
                {validationMessage}
              </div>
            )}

            <div className="createtrade-currbalance">
              <i className="fas fa-info-circle"></i> {t("p2p.trade_input.balance")}{" "}
              <span className="createtrade-currbalance-amount">
                {offer.cryptoCurrency?.code === "USDT" ? "$" : offer.cryptoCurrency?.code}{" "}
                {showBalance ? (
                  <>
                    {new Intl.NumberFormat("en-US", {
                      style: "decimal",
                      maximumFractionDigits: 2,
                    }).format(parseFloat(availableBalance) || 0)}{" "}
                  </>
                ) : (
                  "****"
                )}
              </span>
              <i
                className={`fas ${showBalance ? "fa-eye-slash" : "fa-eye"}`} // Toggle between eye and eye-slash
                style={{ marginLeft: "10px", cursor: "pointer" }}
                onClick={toggleBalanceVisibility}
              ></i>
            </div>
            <h4 className="tradeinput-heading">
              {t("p2p.trade_input.how_much", { verb })}
            </h4>

            <div className="create-trade-cont">
              <div title={t("p2p.trade_input.target_tip")}>
                <label
                  className="create-trade-labels"
                  htmlFor="inputField3"
                >
                  {t("p2p.trade_input.want_to", { verb })}
                </label>
                <div className="input-group mb-1">
                  <input
                    type="text"
                    className={`createtrade-input ${
                      highlightUSD ? "border-danger" : ""
                    }`}
                    id="inlineFormInputGroup2"
                    value={cryptoAmount}
                    placeholder="0.00"
                    onChange={(e) => onCryptoChange(e.target.value)}
                  />

                  <div className="currency-code-tag">
                    <p
                      className={`${
                        highlightUSD ? "border-danger" : ""
                      }`}
                    >
                      {offer.cryptoCurrency?.code == "USDT"
                        ? "USD"
                        : offer.cryptoCurrency?.code}
                    </p>
                  </div>
                </div>
              </div>
              <div title={t("p2p.trade_input.limits_tip")}>
                <label
                  className="create-trade-labels"
                  htmlFor="inputField2"
                >
                  {offerTypeDisplay === "sell"
                    ? t("p2p.trade_input.will_receive")
                    : t("p2p.trade_input.will_pay")}
                </label>
                <div className="input-group createtrade-inputsection">
                  <input
                    type="text"
                    className={`createtrade-input ${
                      highlightFIAT ? "border-danger" : ""
                    }`}
                    id="inlineFormInputGroup1"
                    placeholder="0.00"
                    value={fiatAmount}
                    onChange={(e) => onFiatChange(e.target.value)}
                  />
                  <div className="currency-code-tag">
                    <p>
                      {offer.fiatCurrency?.code}
                    </p>
                  </div>
                </div>
                <br />
              </div>
            </div>
            <div className="create-trade-cont">
              {offer?.offerTypeField === "buy" ? (
                offer?.paymentMethod?.slug === "bank-transfer" ? (
                  <div>
                    <div>
                      <div className="input-group createtrade-inputsection">
                        <div className="label">
                          <div>
                            <label
                              htmlFor="inputField3"
                              className="create-trade-labels"
                            >
                              {t("p2p.trade_input.select_account")}
                            </label>
                          </div>
                          <div>
                            <a
                              href="/p2p_trades/payment_methods/bank_accounts"
                              className="createtrade-addbankaccount"
                            >
                              <i className="fas fa-plus-circle"></i>
                              {" "}
                              {t("p2p.trade_input.add_account")}
                            </a>
                          </div>
                        </div>

                        <div className="input-group createtrade-inputsection">
                          <select
                            className="createtrade-dropdown"
                            value={selectedValue}
                            onChange={handleSelectChange}
                          >
                            <option value="" disabled>
                              {t("p2p.trade_input.select_bank")}
                            </option>
                            {userBankAccounts.map((account) => (
                              <option key={account.value} value={account.label}>
                                {account.label}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div>
                    <div>
                      <div>
                        <label
                          htmlFor="inputField3"
                          className="create-trade-labels"
                        >
                          {t("p2p.trade_input.enter_details", { method: offer.paymentMethod?.name })}
                       
                          <p className="createtrade-paymentmethod-description">{t("p2p.trade_input.provide_info", { method: offer.paymentMethod?.name })}</p>
                        </label>
                        <textarea
                          className="createtrade-input"
                          value={selectedValue}
                          onChange={handleSelectChange}
                        >
                        </textarea>
                      </div>
                    </div>
                  </div>
                )
              ) : (
                <></>
              )}
            </div>

            <div 
              className={`extra-transaction-summary-container ${offerTypeDisplay === 'sell' ? 'createtrade-sell' : 'createtrade-buy'}`}
            >
              <div className="extra-transaction-summary-row">
                <div className="extra-transaction-summary">
                  <div className="extra-transaction-summary-details">
                    <p>{t("p2p.trade_input.subtotal")}</p>
                    <div className="extra-transaction-summary-details-price">
                      ${" "}
                      {new Intl.NumberFormat("en-US", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      }).format(
                        parseFloat(cryptoAmount || "0.00")
                      )}{" "}
                      <br />
                      <small>
                      {new Intl.NumberFormat("en-US", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      }).format(
                        parseFloat(fiatAmount || "0.00")
                      )}{" "}
                        {offer.fiatCurrency?.code}{" "}
                      </small>
                    </div>
                  </div>
                  {offerTypeDisplay === "sell" && tradeFee && (
                    <div className="extra-transaction-summary-details" title={t("p2p.amount.fee_tip")}>
                      <p>
                        <span className="createtrade-fee-helpbubble">
                          <CirlceQuestionmark />
                        </span>
                        <span>{t("p2p.trade_input.fee")}</span>
                      </p>
                      <div className="extra-transaction-summary-details-price">
                          ${" "}
                          {new Intl.NumberFormat("en-US", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          }).format(
                            calculateTradeFee(cryptoAmount, tradeFee)
                          )}{" "}
               
                        <br />
                        <small>
                          {new Intl.NumberFormat("en-US", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          }).format(
                           calculateFiatTradeFee(cryptoAmount, tradeFee, sellerRate)
                          )}{" "}
                          {offer.fiatCurrency?.code}{" "}
                        </small>
                      </div>
                    </div>
                  )}

                  <div className="extra-transaction-summary-details">
                    <p className="iwill-sellbuy">
                      <span>{t("p2p.trade_input.i_will")}</span>
                      <span>
                        {offerTypeDisplay === "sell"
                        ? t("p2p.trade_input.receive_colon")
                        : t("p2p.trade_input.pay_colon")}
                      </span>
                    </p>
                    <div className="extra-transaction-summary-details-price">
                      {new Intl.NumberFormat("en-US", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      }).format(
                        parseFloat(fiatAmount || "0.00")
                      )}{" "}
                      {offer.fiatCurrency?.code}
                    </div>
                  </div>
                </div>
              </div>
                    <button
                      className={`createtrade-button ${offerTypeDisplay === 'sell' ? 'createtrade-sellbtn' : 'createtrade-buybutton'}`}
                      onClick={(e) => onSubmit(e)}
                      disabled={submitting}
                    >
                      {!offer || submitting
                        ? t("p2p.trade_input.please_wait")
                        : offerTypeDisplay === "buy"
                        ? t("p2p.trade_input.buy_now")
                        : offerTypeDisplay === "sell"
                        ? t("p2p.trade_input.sell_now")
                        : t("p2p.trade_input.now")}
                    </button>
            </div>
            <div className="createtrade-profile-details">
              <div className="text-center">
                {t("p2p.trade_input.escrow")} <br />
                <div className="createtrade-offer-title font-weight-bold font-0_9">
                  {offer.customOfferLabel}
                </div>
                <div title={`${offer.profile?.name}`}>
                <a href={`/profile/${offer.profile?.userName}`} className="font-0_9 font-weight-bold createtrade-profile-name" target="_blank" rel="noopener noreferrer">
                          <i className="fa fa-user-circle"></i>{" "}
                          {offer.profile?.name.length > 20 ? `${offer.profile?.name.slice(0, 20)}...` : `${offer.profile?.name.slice(0, 20)}`}{" "}
                          </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TradeInput;
